import React from 'react';
import PropTypes from 'prop-types';

import { round1, round2 } from '../../lib/format';
import { title, value } from './translations';
import Spinner from '../shared/Spinner';

const COUNT_STATS = [
  'pts',
  'fgm',
  'fga',
  'fgm3',
  'fga3',
  'ft',
  'fta',
  'rebs',
  'rebsd',
  'rebso',
  'ast',
  'blk',
  'stl',
  'to',
  'fouls',
];

const TeamCountingStats = ({ stats }) => {
  return (
    <section className="s-advanced-stats__data">
      {stats ? (
        <div className="stats-table__fixed-container">
          <div className="stats-table__container">
            <table className="stats-table">
              <TableHeader />

              <TableBody stats={stats} />
            </table>
          </div>
        </div>
      ) : (
        <Spinner />
      )}
    </section>
  );
};

TeamCountingStats.propTypes = {
  stats: PropTypes.object,
};

export default TeamCountingStats;

const TableHeader = () => (
  <thead>
    <tr>
      <th></th>
      <th className="stats-table__column-title" colSpan="2">
        TOTAL
      </th>
      <th className="stats-table__column-title" colSpan="2">
        PER GAME
      </th>
    </tr>
    <tr>
      <th></th>
      <th className="stats-table__column-title">TEAM</th>
      <th className="stats-table__column-title">OPPONENT</th>
      <th className="stats-table__column-title">TEAM</th>
      <th className="stats-table__column-title">OPPONENT</th>
    </tr>
  </thead>
);

const TableBody = ({ stats }) => (
  <tbody>
    <TableRowGames stats={stats} />
    <TableRowPossessions stats={stats} />

    {COUNT_STATS.map(stat => (
      <TableStatRow key={stat} stats={stats} stat={stat} />
    ))}
  </tbody>
);

const TableRowGames = ({ stats }) => {
  return (
    <tr>
      <th className="stats-table__row-title" title="Games">
        Games
      </th>
      <td colSpan="4" title="Games">
        {stats.team.calculated.num_games}
      </td>
    </tr>
  );
};

const TableRowPossessions = ({ stats }) => (
  <tr>
    <th className="stats-table__row-title" title="Possessions">
      Possessions
    </th>
    <td colSpan="2" title="Possessions">
      {round2(stats.team.calculated.possessions)}
    </td>
    <td colSpan="2" title="Possessions Per Game">
      {round2(
        stats.team.calculated.possessions / stats.team.calculated.num_games,
      )}
    </td>
  </tr>
);

const TableStatRow = ({ stats, stat }) => {
  const games = stats.team.calculated.num_games || 1;
  const totalTeamValue = stats.team.boxscore[stat];
  const totalOpponentValue = stats.opponent.boxscore[stat];

  const gameTeamValue = round1(totalTeamValue / games);
  const gameOpponentValue = round1(totalOpponentValue / games);

  return (
    <tr>
      <th className="stats-table__row-title" title={title(stat)}>
        {title(stat)}
      </th>

      <StatValue
        stat={stat}
        teamValue={totalTeamValue}
        opponentValue={totalOpponentValue}
      />
      <StatValue
        stat={stat}
        teamValue={gameTeamValue}
        opponentValue={gameOpponentValue}
      />
    </tr>
  );
};

const StatValue = ({ stat, teamValue, opponentValue }) => {
  let isTeamBetter = teamValue >= opponentValue;
  let isOpponentBetter = opponentValue >= teamValue;

  return (
    <>
      <td title={title(stat)} className={isTeamBetter ? 'highlight' : ''}>
        {value(stat, teamValue)}
      </td>

      <td title={title(stat)} className={isOpponentBetter ? 'highlight' : ''}>
        {value(stat, opponentValue)}
      </td>
    </>
  );
};
